import * as React from 'react';
import { cn } from '@/lib/utils';
import FieldErrorMessage from '@/components/sections/field-error-message';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  leftContent?: React.ReactNode;
  leftContentBorder?: boolean;
  rightContent?: React.ReactNode;
  rightContentBorder?: boolean;
  lengthCurrentCharacter?: number;
  limitCharacter?: number;
  smallPreview?: string;
  errorMessage?: string;
  classNameWrapper?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      classNameWrapper,
      leftContent,
      leftContentBorder,
      rightContent,
      rightContentBorder,
      type,
      lengthCurrentCharacter,
      limitCharacter,
      smallPreview,
      errorMessage,
      ...props
    },
    ref
  ) => {
    return (
      <div className={cn('relative', classNameWrapper)}>
        <div className='relative'>
          {leftContent && (
            <div
              className={cn(
                'absolute top-[50%] w-10 -translate-y-[50%] text-center text-sm',
                leftContentBorder && 'border-r'
              )}
            >
              {leftContent}
            </div>
          )}
          <input
            type={type}
            className={cn(
              'flex h-9 w-full rounded-sm border border-input bg-transparent px-3 py-5 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
              leftContent && leftContentBorder && 'pl-12',
              leftContent && !leftContentBorder && 'pl-10',
              rightContent && rightContentBorder && 'pr-12',
              rightContent && !rightContentBorder && 'pr-10',
              className
            )}
            ref={ref}
            {...props}
          />
          {rightContent && (
            <div
              className={cn(
                'absolute right-0 top-[50%] w-10 -translate-y-[50%] text-center text-sm',
                rightContentBorder && 'border-r'
              )}
            >
              {rightContent}
            </div>
          )}
        </div>

        <div className='relative flex items-center overflow-hidden px-1'>
          {errorMessage ? (
            <FieldErrorMessage className='mt-[12px] text-xs' error={errorMessage} />
          ) : (
            smallPreview && <div className='mt-[12px] truncate text-xs'>{smallPreview}</div>
          )}
          {limitCharacter !== undefined && limitCharacter !== null && (
            <div className='ml-auto mt-[12px] text-xs text-gray-500'>
              {lengthCurrentCharacter}/{limitCharacter}
            </div>
          )}
        </div>
      </div>
    );
  }
);
Input.displayName = 'Input';

export { Input };
